<template>
  <div class="min-h-screen bg-gradient-to-b from-gray-50 via-white to-gray-100">
    <div class="mx-auto flex max-w-5xl flex-col items-center px-6 py-20 text-center">
      <div class="relative">
        <div class="absolute -left-16 -top-10 h-24 w-24 rounded-full bg-brand/10 blur-2xl"></div>
        <div class="absolute -right-20 bottom-6 h-28 w-28 rounded-full bg-indigo-200/40 blur-3xl"></div>
        <div class="relative rounded-3xl bg-white px-10 py-12 shadow-2xl ring-1 ring-gray-100">
          <p class="text-sm font-semibold uppercase tracking-wide text-brand">Error 404</p>
          <h1 class="mt-3 text-4xl font-bold text-ink sm:text-5xl">This page took a detour</h1>
          <p class="mt-3 max-w-2xl text-base text-muted">
            We couldn’t find the page you’re looking for. Check the address, or head back to safety with the options below.
          </p>
          <div class="mt-6 flex flex-wrap items-center justify-center gap-3">
            <RouterLink
              class="rounded-full bg-brand px-5 py-3 text-sm font-semibold text-white shadow-card transition hover:-translate-y-0.5 hover:bg-brandDark"
              to="/"
            >
              Go home
            </RouterLink>
            <RouterLink
              class="rounded-full bg-white px-5 py-3 text-sm font-semibold text-ink shadow-card ring-1 ring-gray-200 transition hover:-translate-y-0.5 hover:text-brand"
              to="/vendors"
            >
              Find vendors
            </RouterLink>
            <RouterLink
              class="rounded-full bg-white px-5 py-3 text-sm font-semibold text-ink shadow-card ring-1 ring-gray-200 transition hover:-translate-y-0.5 hover:text-brand"
              to="/use-cases"
            >
              Explore use cases
            </RouterLink>
          </div>
        </div>
      </div>
      <div class="mt-10 grid gap-4 text-left sm:grid-cols-2">
        <div class="rounded-2xl bg-white p-4 shadow-card ring-1 ring-gray-100">
          <p class="text-sm font-semibold text-ink">Need help?</p>
          <p class="text-sm text-muted">Visit our blog for guides, or drop us a note via contact.</p>
          <RouterLink class="mt-2 inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" to="/contact">
            Contact support
            <span aria-hidden="true">→</span>
          </RouterLink>
        </div>
        <div class="rounded-2xl bg-white p-4 shadow-card ring-1 ring-gray-100">
          <p class="text-sm font-semibold text-ink">Popular links</p>
          <ul class="mt-2 space-y-1 text-sm text-muted">
            <li><RouterLink class="hover:text-brand" to="/venues">Browse venues</RouterLink></li>
            <li><RouterLink class="hover:text-brand" to="/vendor-search">Search vendors</RouterLink></li>
            <li><RouterLink class="hover:text-brand" to="/categories">View categories</RouterLink></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundView'
}
</script>
